import React from "react";
import { values } from "mobx";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";

import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";

import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

const styles = () => ({
  pageName: {
    fontWeight: "bold"
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  listRow: {
    cursor: "pointer"
  },
  listHeaderCell: {
    fontSize: "0.9rem"
  },
  listBodyCell: {
    fontSize: "1.05rem"
  },
  iconTableWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end"
  }
});

class SensorGroupList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: undefined
    };
  }

  componentDidMount() {
    this.setState(state => ({
      ...state,
      loading: true
    }));

    this.props.rootStore.sensorGroupStore.fetchAndUpdate().then(() =>
      this.setState(state => ({
        ...state,
        loading: false
      }))
    );
  }

  redirectToSensorGroup(id) {
    this.setState(() => {
      return {
        redirect: `${this.props.match.url}/${id}`
      };
    });
  }

  render() {
    if (!(this.state.redirect === undefined)) {
      return <Redirect push to={this.state.redirect} />;
    }

    const classes = this.props.classes;

    if (this.state.loading) {
      return (
        <div className={classes.progressContainer}>
          <CircularProgress className={classes.progress} />
        </div>
      );
    }

    const sensorGroups = this.props.rootStore.sensorGroupStore.sensor_groups;

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.pageName}>
              All Sensors
            </Typography>
          </Grid>
        </Grid>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.listHeaderCell}>
                Sensor Name
              </TableCell>
              <TableCell className={classes.listHeaderCell} align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {values(sensorGroups)
              .sort((a, b) => a.human_name.localeCompare(b.human_name))
              .map(sensorGroup => (
                <TableRow
                  className={classes.listRow}
                  key={sensorGroup.id}
                  onClick={() => this.redirectToSensorGroup(sensorGroup.id)}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.listBodyCell}
                  >
                    {sensorGroup.human_name}
                  </TableCell>
                  <TableCell align="right" className={classes.listBodyCell}>
                    <div className={classes.iconTableWrapper}>
                      <KeyboardArrowRightIcon />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(
  inject(stores => ({
    rootStore: stores.rootStore
  }))(observer(SensorGroupList))
);
